// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__WArsW","description":"MealItem_description__EjvkW","price":"MealItem_price__M4Otk"};